import axiosInstance from '../config/axios.js';

const API_BASE = '/ti-reports';

const tiReportService = {
  // Get all TI reports with optional filters and pagination
  getAll: async (page = null, perPage = 10, params = {}) => {
    const queryParams = page !== null
      ? { page, per_page: perPage, ...params }
      : { all: 'true', ...params };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get all TI reports without pagination
  getAllReports: async (params = {}) => {
    const queryParams = {
      all: 'true',
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get client published TI reports (for clients)
  getClientReports: async (clientId, page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      client_id: clientId,
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(`${API_BASE}/client`, { params: queryParams });
    return response.data;
  },

  // Get TI report by ID
  getById: async (reportId) => {
    const response = await axiosInstance.get(`${API_BASE}/${reportId}`);
    return response.data;
  },

  // Create new TI report
  create: async (reportData) => {
    const response = await axiosInstance.post(API_BASE, reportData);
    return response.data;
  },

  // Update TI report
  update: async (reportId, reportData) => {
    const response = await axiosInstance.put(`${API_BASE}/${reportId}`, reportData);
    return response.data;
  },

  // Toggle published status
  togglePublished: async (reportId) => {
    const response = await axiosInstance.patch(`${API_BASE}/${reportId}/toggle-published`);
    return response.data;
  },

  // Delete TI report
  delete: async (reportId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${reportId}`);
    return response.data;
  },

  // Generate certificate / report PDF
  generateCertificate: async (reportId) => {
    const response = await axiosInstance.get(`${API_BASE}/${reportId}/certificate`, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Toggle send_to_dm status
  toggleSendToDM: async (reportId) => {
    const response = await axiosInstance.patch(`${API_BASE}/${reportId}/toggle-send-to-dm`);
    return response.data;
  },

  // Get pending reports for DM
  getPendingForDM: async (page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(`${API_BASE}/pending-for-dm`, { params: queryParams });
    return response.data;
  },

  // Send bulk email for selected reports
  sendBulkEmail: async (reportIds) => {
    const response = await axiosInstance.post(`${API_BASE}/send-bulk-email`, {
      ids: reportIds
    });
    return response.data;
  },

  // Download bulk PDFs for selected reports (single PDF or ZIP)
  downloadBulkPDF: async (reportIds) => {
    const response = await axiosInstance.post(`${API_BASE}/bulk-pdf-download`, {
      ids: reportIds
    }, {
      responseType: 'blob'
    });
    return response;
  },

  // Export CSV for selected reports
  exportCSV: async (reportIds) => {
    const response = await axiosInstance.post(`${API_BASE}/export-csv`, {
      ids: reportIds
    }, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Duplicate a TI report record
  duplicate: async (reportId) => {
    const response = await axiosInstance.post(`${API_BASE}/${reportId}/duplicate`);
    return response.data;
  },
};

export default tiReportService;